import { Space, Tooltip } from 'antd'
import { VisitSummary } from './visitSummary'
import { CheckCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { green, orange } from '@ant-design/colors'
import { centsToDollarsDisplay } from '../displayFormatters'

export const VisitSelectLabel = ({visit}: {visit: VisitSummary}) => {
  const date = new Date(visit.date)
  return <Space size="large">
    {visit.isReviewed &&
      <Tooltip title="Visit has been reviewed">
        <CheckCircleOutlined style={{ color: green.primary }} />
      </Tooltip>
    }
    {!visit.isReviewed &&
      <Tooltip title="Visit has not been reviewed">
        <QuestionCircleOutlined style={{ color: orange.primary }} />
      </Tooltip>
    }
    <span>{new Date(date).toLocaleDateString()}</span>
    <span>Price: {centsToDollarsDisplay(visit.totalPrice)}</span>
  </Space>
}

export default VisitSelectLabel